import { ORANGE_LEGACY_TEXT_STYLES } from '@junglescout/styles-library'

export const TEXT_STYLES = ORANGE_LEGACY_TEXT_STYLES
